import { DefaultTheme } from "styled-components";

const defaultTheme: DefaultTheme = {
    colors: {
        primary: "",
        primaryTone: "",
        secondary: "",
        secondaryTone: "",

        tertiary: "",

        monotoneMidLight: "",
        monotoneMid: "",
        monotoneMidDark: "",
        monotoneDark: "",

        alert: "",

        accentPrimary: "",
        accentSecondary: "",
        accent3: "",
        accent4: "",
        accent5: "",
        accent6: "",
        accent7: "",
        accent8: "",

        backgroundLightest: "",
        backgroundLighter: "",
        backgroundLight: "",
        backgroundLightTone: "",

        background: "",
        brilliant: ""
    },
    breakpoints: [],
    radii: [],
    fonts: {
        fontFamily: ""
    },
    fontWeights: {
        light: "",
        regular: "",
        semiBold: "",
        bold: ""
    },
    space: [],
    gridCols: 1,
    fontSizes: [],
    lineHeights: [],
    zIndices: [],
    icons: {
        info: "",
        error: "",
        success: ""
    }
};

export default defaultTheme;
